module.exports = __webpack_public_path__ + "static/media/laptop.b98f0cf9.jpg";